// @ts-nocheck
import React, { useState } from "react";
import { AverageViewsGraph } from ".";
import {
  useGetAverageViewsByAccountIdQuery,
  LineChartFilter,
  DataSourcePlatform,
} from "src/generated/ApolloComponents";

interface Props {
  accountId?: string;
  username: string;
  platformType: string;
}

export const AverageViewsGraphContainer: React.FC<Props> = ({
  accountId,
  username,
  platformType,
}) => {
  const [period, setPeriod] = useState("HalfYear");

  let queryData = {
    username: username,
    filter: period as LineChartFilter,
    platformType: platformType as DataSourcePlatform,
  } as any;

  if (accountId) {
    queryData["accountId"] = accountId;
  }

  const { data, loading, error } = useGetAverageViewsByAccountIdQuery({
    variables: queryData,
  });

  const graphData = data?.getAverageViewsByAccountId || [];
  let lastItem = graphData.filter(x => x?.value != null).slice(-1)[0];

  if (!loading && (error || graphData?.length === 0)) return null;

  return (
    <AverageViewsGraph
      loading={loading}
      data={graphData}
      period={period}
      setPeriod={value => setPeriod(value)}
      titleValue={lastItem?.value}
    />
  );
};
